import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-preferences',
  templateUrl: './user-preferences.component.html',
  styleUrls: ['./user-preferences.component.scss']
})
export class UserPreferencesComponent {

  audioList = [
    {name: 'Accomplished', file: 'accomplished'},
    {name: 'Consequence', file: 'consequence'},
    {name: 'Deduction', file: 'deduction'},
    {name: 'Dont Think So', file: 'dont-think-so'},
    {name: 'Falling Into Pplace', file: 'falling-into-pplace'},
    {name: 'Goes Without Saying', file: 'goes-without-saying'},
    {name: 'Got It Done', file: 'got-it-done'},
    {name: 'Intuition', file: 'intuition'},
    {name: 'Origin', file: 'origin'},
    {name: 'Piece of Cake', file: 'piece-of-cake'},
    {name: 'Plucky', file: 'plucky'},
    {name: 'Point Blank', file: 'point-blank'},
    {name: 'Quite Impressed', file: 'quite-impressed'},
    {name: 'Swiftly', file: 'swiftly'},
    {name: 'To The Point', file: 'to-the-point'},
    {name: 'Unconvinced', file: 'unconvinced'},
  ];

  audioList2 = [
    {name: 'Campainha', file: 'campainha'}
  ];

  userData = {
    nickname: 'Corretor Mock',
    phone: '11 98765-4321',
    company: 'Lopes Stilo'
  };

  defaultMessage =
    `Atenciosamente, \n${this.userData.nickname} \nTel/Whatsapp: ${this.userData.phone} \n${this.userData.company}`;

}
